
export default {
  "m":{
    "sms_login":"Accesso tramite messaggio breve",
    "get_vercode":"Inviare",
    "change_mobile":"Cambia numero di telefono",
    "log_reg_agree":"Accedi/Registrati significa accettare {msg_ss}",
    "old_mobile":"Numero di telefono originale",
    "new_mobile":"Nuovo numero di telefono",
    "agency_reginfo_fill":"Inserisci le informazioni di registrazione della gilda",
    "audit_res":"Risultati dell'audit",
    "agency_name":"Nome della gilda",
    "agency_name_input":"Inserisci il nome di una gilda",
    "agency_name_input_note":"Nota: si raccomanda che il nome della gilda sia breve e facile da ricordare, non più di 30 parole",
    "agency_logo":"LOGO della gilda",
    "agency_logo_unpload_note":"Carica un LOGO di gilda chiaro in formato PNG/JPG/JPEG",
    "agency_contact_name":"Persona di contatto della gilda",
    "user_contact_name":"Si prega di inserire il nome della persona che è in contatto quotidiano con la piattaforma utente",
    "agency_contact_phone":"Numero di telefono di contatto della gilda",
    "agency_whatsapp":"Il leader della gilda WhatsApp",
    "agency_whatsapp_contact":"Inserisci le informazioni di contatto WhatsApp del leader della gilda",
    "agency_use_lang":"Linguaggio utilizzato dal capo gilda",
    "agency_head_ID":"ID leader della gilda",
    "agency_ID_input":"Inserisci l'ID utente dell'APP BuzzCast leader della gilda per la successiva distribuzione dei fondi",
    "reg_country":"Paese di registrazione",
    "inhand_ID_photo":"Carta d'identità a portata di mano",
    "upload_note_t":"Carica considerazioni",
    "agency_self_inhand_ID":"Il leader della gilda deve essere in possesso del passaporto per poter scattare la foto",
    "photo_must_clearly":"Il lato anteriore deve mostrare chiaramente la persona e le informazioni reali del passaporto scattando una foto",
    "mian_form_country":"Il paese di origine principale dell'host",
    "invite_code":"Codice invito",
    "your_profile_submit_success":"Il tuo documento è stato inviato con successo! ce ne occuperemo il prima possibile.<br>I risultati dell'audit verranno inviati alla notifica dell' BuzzCast APP del leader della gilda e si prega di prestare attenzione al controllo!",
    "your_profile_approved":"Il documento che hai presentato non ha superato la revisione! Il motivo del rifiuto è la foto del passaporto in possesso non è chiara\".<br>Si prega di ricaricare o contattare l'assistente ufficiale su BuzzCastAPP per una consulenza.",
    "return_refill":"Torna indietro e ricarica",
    "success_agency":"Congratulazioni per la corretta installazione della piattaforma, [cliccami] per iniziare a lavorare!",
    "personal_account":"Account personale",
    "my_agency":"La mia gilda",
    "your_agency_been_forcibly":"La tua gilda è stata chiusa con la forza dalla piattaforma e non sarai più in grado di accedere al sistema. In caso di domande, contatta l'assistente ufficiale di BuzzCastAPP o l'operazione esclusiva.",
    "invite_live_join":"Invita l'host a unirsi al link della gilda",
    "base_info":"Informazioni di base",
    "apply_time":"Data di applicazione",
    "join_time":"Unisciti al tempo",
    "cooper_status":"Stato di cooperazione",
    "streamer_manage":"Gestione host",
    "sereamer_apply":"Approvazione host",
    "sereamer_nickname":"Soprannome host",
    "remark":"Nota",
    "no_remark":"Nessuna osservazione",
    "add_remark":"Aggiungi commenti",
    "birth":"Data di nascita",
    "user_status":"Stato dell'utente",
    "temporarily_frozen":"Congelamento temporaneo",
    "permanently_frozen":"Congelamento per sempre",
    "fans_num":"Numero di seguaci",
    "sign_status":"Stato del contratto",
    "sign_ing":"Sotto contratto",
    "sign_time":"Data del contratto",
    "release_time":"Data di cancellazione",
    "live_viola_record":"Record di violazione della trasmissione in diretta",
    "sign_record":"Registro del contratto",
    "current_contract_status":"Stato attuale del contratto",
    "termination_reason":"Motivo del recesso",
    "violation_reason":"Motivo della violazione",
    "violation_time":"Data di violazione",
    "processing_result":"Risultato del processo",
    "exported_data":"Esporta dati",
    "join_agency_apply":"Approvazione per l'adesione alla gilda",
    "audit_status":"Stato di approvazione",
    "pending_review":"Revisione in atto",
    "pending_HQ_review":"In attesa di revisione della sede",
    "not_approved_HQ":"Non approvato dall'ufficio centrale",
    "withdrawn":"Revocato",
    "audit_trail":"Esamina i record",
    "oper":"Operazione",
    "other_video_materials":"Altri documenti video",
    "pass":"Passato",
    "pass_streamer_join_agency_apply":"Passa l'applicazione per l'host per entrare a far parte della gilda",
    "reject_streamer_join_agency_apply":"Rifiuta la domanda per l'host per entrare a far parte della gilda",
    "agree_streamer_join_agency":"Accetta con anchor {msg_ss1} di diventare un mittente inferiore a {msg_ss2}~",
    "reject_streamer_join_agency":"La richiesta del membro {msg_ss1} di diventare membro di {msg_ss2} è stata respinta!",
    "img_material":"Documenti illustrativi",
    "approver":"Approvatore",
    'user_enter_bind_phone':'Per favore inserisci il numero di telefono',
    'vericode':'Codice di verifica',
    'input_vericode':'Si prega di inserire il codice di verifica',
    'login':'Accesso',
    'reg':'Registrato',
    'logout':'Disconnessione',
    'search_for':'Ricerca',
    'subscription_closed':'Contratto annullato',
    'agency_ID':'Codice della gilda: {msg_ss}',
    'reset':'Ripristina con',
    'live_ID':'ID Camigirl',
    'live_record':'Registrazione dello schermo in diretta',
    'email':'Cassetta postale',
    'phone':'Telefono',
    'mastery_lang':'Mastery language',
    'to':'A',
    'cancel':'Annullare',
    'Confirm':'OK',
    'preview':'Anteprima',
    'rejected':'Respinto',
    'tip':'Richiesta',
    'i_got_it':'Ho capito',
    'cancelled':'Annullato',
    'refused':'Rifiuto',
    'agency_agree':'La gilda ha acconsentito',
    'platform_agree':'La piattaforma ha acconsentito',
    'user_not_exist':'Utente inesistente',
    'user_frozen':'L\'utente è stato congelato',
    'reviewing':'In revisione',
    'review_pass':'Recensione approvata',
    'review_failed':'Controllo non riuscito',
    'xx_hours':'{msg_ss} ore',
    'xx_days':'{msg_ss} giorni',
    'xx_hour': '{msg_ss} Ora',
    'xx_day': '{msg_ss} Giorno',
    'xx_year': '{msg_ss} Anno',
    'xx_years': '{msg_ss} Anni',
    'check_phone_istrue':'Si prega di controllare il numero di telefono se è stato inserito correttamente',
    'male':'Maschio',
    'female':'Femmina',
    'avatar':'Foto profilo',
    'normal':'Normale',
    'live_room':'Sala dal vivo',
    'view':'Vista',
    'oper_success':'Operazione riuscita',
    'copy_success':'Copia riuscita',
    'new_mobile_already_reg':'Nuovo numero di cellulare registrato',
    'general_user':'Utente generico',

    'copy':'Copia',
    'gender':'Genere',
    'submit':'Inviare',
    'permanent':'Permanente',
    'agree_agreement':'Accetta e rispetta il contratto',
    'vericode_error':'Il codice di verifica è errato',
    'resend':'Annulla piace',
    'approved':'Passato',
    'not_approved':'Impossibile passare',
    'agency_rejected':'Piattaforma rifiutata',
    'select':'Selezionare',
    'search':'Ricerca',
    'rejection_reason':'Motivo del rifiuto',
    'no_data':'Nessun dato',
    'oper_failed':'Operazione fallita',
    'leave_agency_apply':'Approvazione per il ritiro della gilda',
    'over_word_limit':'Limite numero di parole superato',
    'delete':'Elimina',
    'nickname':'Soprannome',
    'file_is_too_large':'File troppo grande',

    'community_convention':'Convenzione della comunità Buzzcast',
    'approval_time':'Tempo di approvazione',
    'guild_system_title':'Sistema di gilda della piattaforma sociale BuzzCast',
    'return':'Ritorno',
    'img_upload_fail':'',
    'cooper_ing':'In collaborazione',
    'upload_file_format_incorrect':'Il file caricato non è nel formato corretto',
    'token_invalid':'Il token non è valido, accedi di nuovo!',
    'network_busy':'La rete è occupata, riprova',
    'minute':'{msg_ss}minuto',

    'live_room_ID':'Sala dal vivo ID',
    'scan_code':'Scansiona il codice per accedere a BuzzCast',
    'open_code':'Apri l\'app e fai clic sul mio codice QR per eseguire la scansione',
    'refresh':'Aggiornare',
    'login_confirm':'La conferma del login',
    'account':'Informazioni sull\'account',
    'user_name':'Nome utente',
    'edit':'Modifica',
    'changing':'Modifica del numero di binding',
    'mobile_number':'Numero di conto di cellulare',
    'mobile_login':'Puoi accedere utilizzando il tuo numero di cellulare',
    'appId_login':'Puoi utilizzare l\'ID app dell\'account () per cercare l\'accesso',
    'code_login':'BuzzCastAppID non è collegato. Dopo il collegamento, è possibile eseguire la scansione del codice QR per accedere.',
    'verification_log':'È utilizzare il numero di cellulare e la verifica per accedere se il numero di cellulare mo è associato',
    'binding_success':'Successo vincolante',
    'binding_mobile':'Numero di cellulare vincolante',
    'edit_name':'Modificare un nome utente',
    'binding_alert':'Promemoria della modifica vincolante',
    'new_appId':'L\'ID APP originale verrà sostituito direttamente se il nuovo ID APP viene utilizzato per eseguire la scansione del codice di associazione',
    'binding_account':'Associazione dell\'account dell\'app',
    'anchor_earings':'BuzzCast',
    'signing_date':'Gli orecchini dell\'ancora',
    'statistical_date':'Data della firma',
    'valid_min':'Numero totale valido (min)',
    'valid_day':'Il periodo di validità in giorni',
    'total_revenue':'Entrate totali',

    'bind':'Legare',
    'please_agree_agree':'Si prega di accettare il contratto',
    'note':'Nota: l\'ora visualizzata da questo sistema è l\'ora di New York (EST)',
    'app_phone':'Registra il numero di cellulare dell\'APP',
    'host_num':'Numero di host',
    'enter_host_num':'Inserisci il numero di tutti gli host',
    'platform':'Piattaforma di cooperazione',
    'statement':'Estratto conto bancario mensile',
    'enter_income':'Inserisci il reddito medio mensile',
    'check_commas':'Formato errato. Controlla se le piattaforme multiple sono separate da virgole',
    'submit_success':'Il tuo documento è stato inviato con successo! ce ne occuperemo il prima possibile',
    'usd':'Dollaro statunitense',
    'many_platforms':'Inserisci la piattaforma di trasmissione in diretta con cui hai collaborato in precedenza, fino a 20 piattaforme',
    'limit_platform': 'Fino a 20 piattaforme',
    'user_has_delete':'L\'utente è stato annullato',
    'cant_commit':'Sei già un\'emittente a contratto e non puoi richiedere l\'insediamento di una gilda allo stesso tempo',
    'cant_commit_1':'Hai già fatto domanda per un\'emittente convenzionata e non puoi richiedere contemporaneamente l\'insediamento di una gilda',
    'passwd': 'Parola d\'ordine',
    'passwd_placeholder': 'La tua password dovrebbe contenere da 6 a 20 caratteri',
    'live_rights': 'Valutazione senza tempo',
    'edit_log': 'Cambia registro',
    'edit_time': 'Cambia l\'ora',
    'edit_pwd': 'Cambiare la password',
    'old_pwd': 'Vecchia password',
    'new_pwd': 'Nuova password',
    'confirm_pwd': 'Confermare la password',
    'forget_pwd': 'Ha dimenticato la password?',
    'email_check': 'Il formato e-mail non è corretto',
    'phone_pwd_error': 'Numero di telefono o password errati',
    'ten_min_error': 'Riprovare tra 10 minuti',
    'phone_bind_error': 'Il numero di cellulare è stato associato ad altri account, sostituire il nuovo numero di cellulare da associare.',
    'bc_user_id_tip': 'Buzzcast APP ID',
    'bc_user_id_error': 'L\'ID del leader della gilda è già stato compilato, si prega di compilarlo di nuovo',
    'pwd_error': 'Password errata',
    'phone_not_reg_error': 'L\'account non è registrato',
    'pwd_nq': 'Le nuove password inserite sono incoerenti',
    'sign_anchor_error': 'Sei già un\'emittente a contratto e non puoi richiedere l\'insediamento di una gilda allo stesso tempo',
    'apply_anchor_error': 'Hai già fatto domanda per un\'emittente convenzionata e non puoi richiedere contemporaneamente l\'insediamento di una gilda',
    'have-expired':'Scaduto',
    'approval-time':'Tempo di elaborazione',
    'reasons-for-refusal':'Inserisci il motivo del rifiuto',
    'Transfer-grounds':'Motivi del trasferimento',
    'code_expire': 'Il codice di verifica è scaduto, fare clic sul codice di verifica per aggiornare',
    'transfer-approval':'Approvazione del trasferimento',
    'live_state_placeholder': 'Stato della trasmissione',
    'live_state_open': 'Normale',
    'live_state_temporary_banned': 'Vietato',
    'live_state_forever_banned': 'Vietato definitivamente',
    'live_allowed_time': 'Ora di inizio consentita',
    'live_banned_time': 'periodo di divieto',
    'deduct_money': 'Dedurre la quantità di monete B',
    'final_income': 'Reddito reale',
    'select_start_dt': 'Si prega di selezionare un orario di inizio',
    'select_end_dt': 'Si prega di selezionare un orario di fine',
    'less_then_end_dt': 'L\'ora di inizio deve essere inferiore o uguale all\'ora di fine',
    'System_automatically_through':'Il sistema passa automaticamentei',
    'btrade_err': 'L\'ID dell\'agenzia non è disponibile',

    'mouth_anchor': 'Ancoraggio salariale mensile',
    'day_anchor': 'Ancoraggio salariale giornaliero',
    'guild_anchor': "Ricompensa del capo dell'associazione di ancoraggio (stipendio giornaliero)",
    'mouth_anchor_st': 'Orario di inizio stipendio mensile',
    'mouth_anchor_et': 'Orario di fine stipendio mensile',
    'day_anchor_st': 'Orario di inizio stipendio giornaliero',
    'day_anchor_et': 'Orario di fine stipendio giornaliero',
    'all_award_bcoin': 'Reddito totale del compenso salariale giornaliero',
    'live_hour': 'Compenso di durata valida per la trasmissione in diretta',
    'salary_day': 'Data',
    'day_in_come': "Reddito giornaliere dell'associazione (monete B)",
    'award_ration_flag_str': 'Rapporto di compenso',
    'payable_money': "Compenso in moneta B del capo dell'associazione",
    'host_bcoins': "Monete B guadagnate dall'ancora",
    'total_official': 'Numero totale di monete B della ricompensa ufficiale',
    'actual_bcoins_awarded': 'Monete B della ricompensa effettiva',
    "change_bound_account":"Cambia account associato" ,
    "agent_id_form":"ID capogilda:" ,
    "BuzzCast_verification_code":"Codice di verifica BuzzCast:" ,
    "send_success":"Invia successo" ,
    "account_changed_successfully":"Cambio account associato riuscito" ,
    "invite_guild_url":"Link per invitare a diventare capogilda di BuzzCast: {msg_ss}" ,
    "invite_guild_code":"Il mio codice di invito: {msg_ss}" ,
    "save":"Salvare" ,
    "compile":"Modifica" ,
    "agent_nvitation_eward":"Ricompensa per il capogilda" ,
    "agent_name":"Soprannome capogilda" ,
    "guild_id":"Codice di gilda" ,
    "guild_income_30days":"Guadagni della gilda negli ultimi 30 giorni" ,
    "guild_invite_income_30days":"Guadagni da inviti ad altre gilde negli ultimi 30 giorni" ,
    "agency_commission_ratio":"Tasso di Commissione Agenzia" ,
    "invite_income_bcoins":"L'invito premia le monete B" ,
    "id_not_exist": "L'ID non esiste",
    'reward_distribution_status': 'Stato della distribuzione del premio',
    'must_number': 'Il tuo input deve essere in formato puramente numerico.',

  },
}



// WEBPACK FOOTER //
// ./src/i18n/lang/it.js